export default __webpack_public_path__ + "static/media/house_s.5c3c57dc.png";